import { ThunkResult } from '../../../stores/types';
import formatErrorResponseV2 from '../../../utilities/format-error-response-v2';
import ActionTypes from '../constants/action-types';

export default function fetchChannelOrganization(
  organizationId: string,
): ThunkResult<Promise<io.flow.channel.v0.models.ChannelOrganization | undefined>> {
  return (dispatch, getState, extra):
  Promise<io.flow.channel.v0.models.ChannelOrganization | undefined> => {
    dispatch({
      type: ActionTypes.FETCH_CHANNEL_ORGANIZATION_REQUEST,
    });

    return extra.apiInternal(getState()).flowChannelOrganizations
      .get({
        organization_id: organizationId,
        limit: 1,
      }).then((response) => {
        if (response.ok) {
          const channelOrganization = response.body.length > 0 ? response.body[0] : undefined;
          dispatch({
            type: ActionTypes.FETCH_CHANNEL_ORGANIZATION_SUCCESS,
            payload: channelOrganization,
          });
          return channelOrganization;
        }
        dispatch({
          type: ActionTypes.FETCH_CHANNEL_ORGANIZATION_FAILURE,
          payload: formatErrorResponseV2(response),
          error: true,
        });
        return undefined;
      }).catch((e: unknown) => {
        console.error('[fetchChannelOrganization] Malformed API response:', e);
        dispatch({
          type: ActionTypes.FETCH_CHANNEL_ORGANIZATION_FAILURE,
          payload: {
            messages: [{
              message: e instanceof Error ? e.message : 'Unknown error',
            }],
          },
          error: true,
        });
        return undefined;
      });
  };
}
